var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":""}},[_c('span',[_vm._v("© 2020 دکورآرای")])])
}
var staticRenderFns = []

export { render, staticRenderFns }